import React from "react";
import { Helmet } from "react-helmet-async";

const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title} - Daniel Teshome</title>
    </Helmet>
  );
};

export default PageTitle;
